import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={36}
            height={36}
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect x={2} y={2} width={32} height={32} rx={16} fill={theme["#B4E3E1"]} />
            <path
                d="M20.8 24h-6.18c-.403 0-.605 0-.698-.08a.333.333 0 01-.116-.28c.01-.122.152-.265.438-.55l5.668-5.67c.264-.263.396-.395.549-.445a.667.667 0 01.412 0c.152.05.284.182.548.446L24 20v.8M20.8 24c1.12 0 1.68 0 2.108-.218a2 2 0 00.874-.874C24 22.48 24 21.92 24 20.8M20.8 24h-5.6c-1.12 0-1.68 0-2.108-.218a2 2 0 01-.874-.874C12 22.48 12 21.92 12 20.8v-5.6c0-1.12 0-1.68.218-2.108a2 2 0 01.874-.874C13.52 12 14.08 12 15.2 12h5.6c1.12 0 1.68 0 2.108.218a2 2 0 01.874.874C24 13.52 24 14.08 24 15.2v5.6m-7-5.133a1.333 1.333 0 11-2.667 0 1.333 1.333 0 012.667 0z"
                stroke={theme["#0D968F"]}
                strokeWidth={1.33333}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect
                x={2}
                y={2}
                width={32}
                height={32}
                rx={16}
                stroke={theme["#E7F6F5"]}
                strokeWidth={4}
            />
        </svg>
    )
}
  
  export default SvgComponent